import { InputLabelProps, TextField as MUITextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import clsx from 'clsx';

type TextFieldProps = {
  variant?: 'filled' | 'outlined' | 'standard';
  multiline?: boolean;
  rows?: number;
  name?: string;
  disabled?: boolean;
  color?: 'primary' | 'secondary';
  label?: string | React.ReactNode;
  value?: string | number | null;
  error?: boolean;
  helperText?: string;
  handleBlur?: any;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  InputProps?: any;
  inputProps?: any;
  LabelProps?: Partial<InputLabelProps>;
  placeholder?: string;
  rowsMax?: number;
  fullWidth?: boolean;
  style?: {};
  inputRef?: any;
  customClassName?: string;
  handleFocus?: any;
  size?: "medium" | "small" | undefined
};

const useStyles = makeStyles((theme: any) => ({
  input: {
    '&:focus': { backgroundColor: theme.palette.background.default },
    '& .MuiFilledInput-root': {
      textTransform: 'none',
      fontSize: '0.875rem',
      color: theme.palette.text.primary,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      backgroundColor: theme.palette.background.default,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
    },
    '& .Mui-disabled': { cursor: 'not-allowed' },
  },
}));

const TextField = ({
  variant,
  multiline,
  rows,
  name,
  disabled,
  color,
  label,
  value,
  error,
  helperText,
  handleBlur,
  onChange,
  InputProps,
  inputProps,
  LabelProps,
  placeholder,
  rowsMax,
  fullWidth,
  style,
  inputRef,
  customClassName,
  handleFocus,
  size
}: TextFieldProps) => {
  const classes = useStyles();

  return (
    <MUITextField
      onFocus={handleFocus}
      fullWidth={fullWidth}
      variant={variant}
      multiline={multiline}
      minRows={rows}
      name={name}
      color={color}
      disabled={disabled}
      className={clsx(classes.input, customClassName)}
      label={label}
      value={value ?? ''}
      error={error}
      helperText={helperText}
      onBlur={handleBlur}
      onChange={onChange}
      InputProps={InputProps}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={inputProps}
      InputLabelProps={LabelProps}
      placeholder={placeholder}
      style={style}
      inputRef={inputRef}
      maxRows={rowsMax}
      size={size}
    />
  );
};

TextField.defaultProps = {
  variant: 'filled',
  multiline: false,
  rows: 4,
  name: undefined,
  color: 'primary',
  label: '',
  disabled: false,
  error: false,
  helperText: undefined,
  handleBlur: undefined,
  onChange: () => { },
  InputProps: undefined,
  placeholder: undefined,
  rowsMax: 6,
  value: '',
  fullWidth: true,
  style: {},
  customClassName: undefined,
  inputRef: undefined,
  handleFocus: undefined,
  size: undefined
};

export default TextField;
